import { useMutation } from 'react-query';
import axios from 'axios';

import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { AwsConfigApiGateway } from '@/utils/config/api';

async function deleteTeleteTemplateById(templateId: string, token: string | undefined) {
  const response = await axios.delete<string>(`${AwsConfigApiGateway.pooledTenantApiUrl}/templates/${templateId}`, {
    headers: {
      'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
      Authorization: 'Bearer ' + token,
    },
  });
  return response.data;
}

export function useDeleteTemplateById() {
  const { user } = useAuth();
  return useMutation<string, Error, string>((data) =>
    deleteTeleteTemplateById(data, user?.signInUserSession.idToken.jwtToken),
  );
}
